/**
 * TimelineHeader Component
 * Zoom controls and time ruler for the arrangement view
 */

import React from 'react';
import { Button } from '../../ui/button';
import { ZoomIn, ZoomOut } from 'lucide-react';

export const TimelineHeader = ({
  zoom,
  setZoom,
  minZoom = 0.5,
  maxZoom = 4,
  zoomStep = 0.25,
  children, // For the time ruler
}) => {
  return (
    <div className="h-8 bg-zinc-900/30 backdrop-blur-sm border-b border-zinc-800/50 flex items-center px-2 md:px-4 flex-shrink-0">
      <div className="flex items-center gap-1 md:gap-2">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => setZoom(Math.max(minZoom, zoom - zoomStep))} 
          className="p-1"
          data-testid="zoom-out"
        >
          <ZoomOut className="w-4 h-4 text-zinc-400" />
        </Button>
        <span className="text-xs text-zinc-500 w-10 text-center">{Math.round(zoom * 100)}%</span>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => setZoom(Math.min(maxZoom, zoom + zoomStep))} 
          className="p-1"
          data-testid="zoom-in"
        >
          <ZoomIn className="w-4 h-4 text-zinc-400" />
        </Button>
      </div>
      
      {/* Time ruler container */}
      <div className="flex-1 ml-4 relative h-full overflow-hidden">
        {children}
      </div>
    </div>
  );
};

export default TimelineHeader;
